import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { browserRoutes } from "../../config/browserRoutes";

const PageNotFound = () => {
  const authData = useSelector((state) => state?.auth);
  const navigate = useNavigate();
  return (
    <div className="h-screen flex justify-center items-center">
      <div className="flex flex-col items-center">
        <h1 className="text-[78px] font-extrabold pb-2 text-primary">404</h1>
        <p className="text-base font-medium pb-[18px]">Oops! Page not found.</p>
        <p className="text-xs pb-6">
          We could not find the page you were looking for.
        </p>
        <Button
          type="primary"
          onClick={() =>
            navigate(
              authData?.isLogin
                ? browserRoutes?.analytics
                : browserRoutes?.login
            )
          }
        >
          Back Home
        </Button>
      </div>
    </div>
  );
};

export default PageNotFound;
